import MDrawer from './Drawer.vue';

export default MDrawer;
